import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: number;
  rating: number;
  thumbnail: string;
  date?: string;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}

export default function VideoCard({ id, title, category, categorySlug, duration, views, rating, thumbnail }: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        {/* Duration Badge */}
        <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded-md font-medium">
          {duration}
        </span>
        {/* Rating Badge */}
        <span className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 backdrop-blur-sm text-accent-400 text-xs rounded-md font-medium flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </span>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
          {title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md font-medium">
            {category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(views)}
          </span>
        </div>
      </div>
    </Link>
  );
}